import React, { useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Btn } from "../../AbstractElements";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "react-feather";
import { storeDispatch } from "../../store";
import { login } from "../../store/auth";
import { userService } from "../../services/userService";

const ChangePasswordCard = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (!currentPassword) {
      toast.error("Current password is required");
      return;
    }
    if (!newPassword) {
      toast.error("New password is required");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setPasswordLoading(true);
    try {
      const response = await userService.changePassword({ currentPassword, newPassword, confirmPassword });

      storeDispatch(login({ user: response }));

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      toast.success("Password changed successfully");
    } catch (error) {
      console.error("Password change failed:", error);
      const message =
        error.response?.data?.message || "Failed to change password";
      toast.error(message);
    } finally {
      setPasswordLoading(false);
    }
  };

  const toggleStyle = {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
  };

  return (
    <Col md="6">
      <Card>
        <CardHeader className="pb-0">
          <h5>Change Password</h5>
        </CardHeader>
        <CardBody>
          <Form onSubmit={handlePasswordChange}>
            <FormGroup className="position-relative">
              <Label htmlFor="currentPassword">Current Password</Label>
              <div className="position-relative">
                <Input
                  id="currentPassword"
                  type={showCurrentPassword ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  disabled={passwordLoading}
                  placeholder="Enter current password"
                  required
                />
                <div
                  className="show-hide"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  style={toggleStyle}
                >
                  {showCurrentPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </div>
              </div>
            </FormGroup>
            <FormGroup className="position-relative">
              <Label htmlFor="newPassword">New Password</Label>
              <div className="position-relative">
                <Input
                  id="newPassword"
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={passwordLoading}
                  placeholder="Enter new password (min 8 characters)"
                  minLength={8}
                  required
                />
                <div
                  className="show-hide"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={toggleStyle}
                >
                  {showNewPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </div>
              </div>
            </FormGroup>
            <FormGroup className="position-relative">
              <Label htmlFor="confirmPassword">Confirm Password</Label>
              <div className="position-relative">
                <Input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={passwordLoading}
                  placeholder="Confirm new password"
                  required
                />
                <div
                  className="show-hide"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={toggleStyle}
                >
                  {showConfirmPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </div>
              </div>
            </FormGroup>
            <Btn
              attrBtn={{
                color: "primary",
                type: "submit",
                disabled: passwordLoading,
              }}
            >
              {passwordLoading ? "Changing..." : "Change Password"}
            </Btn>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ChangePasswordCard;
